import { useAuth } from '../contexts/AuthContext';
import {
  canDraft,
  canSend,
  canExecute,
  canAccessPortfolioConstruction,
  canAccessPortfolioRebalancing,
  canAccessPortfolioHedging,
  canEdit,
  canManageSecurityMaster,
  isPlatformAdmin
} from '../utils/roleUtils';

export const useRole = () => {
  const { user } = useAuth();
  const userRole = user?.role;

  return {
    userRole,
    canDraft: canDraft(userRole),
    canSend: canSend(userRole),
    canExecute: canExecute(userRole),
    canAccessPortfolioConstruction: canAccessPortfolioConstruction(userRole),
    canAccessPortfolioRebalancing: canAccessPortfolioRebalancing(userRole),
    canAccessPortfolioHedging: canAccessPortfolioHedging(userRole),
    canEdit: canEdit(userRole),
    canManageSecurityMaster: canManageSecurityMaster(userRole),
    isPlatformAdmin: isPlatformAdmin(userRole),
    isAdmin: userRole === 'ADMIN' || userRole === 'PLATFORM_ADMIN',
    isTenantAdmin: userRole === 'ADMIN',
    isTrader: userRole === 'TRADER',
    isPortfolioManager: userRole === 'PORTFOLIO_MANAGER',
    isReferenceDataManager: userRole === 'REFERENCE_DATA_MANAGER',
    isUser: userRole === 'USER'
  };
};
